import { createContext } from "react";
import { AuthContextType } from "./types";

// إنشاء سياق المصادقة
export const AuthContext = createContext<AuthContextType | undefined>(undefined);
